if (!customElements.get('selling-plan-selector')) {
  customElements.define(
    'selling-plan-selector',
    class SellingPlanSelector extends HTMLElement {
      connectedCallback() {
        this.section = this.dataset.section;
        this.input = this.querySelector('[data-selling-plan-input]');
        this.oneTimePriceEl = this.querySelector('[data-one-time-price]');

        const dataScript = document.querySelector(`[data-selling-plan-selector-data="${this.section}"]`);
        this.data = dataScript ? JSON.parse(dataScript.textContent) : { variants: {} };

        this.root = document.getElementById(`shopify-section-${this.section}`) || document;
        this.variantInput = this.root.querySelector('input[name="id"]');
        this.quantityInput =
          this.root.querySelector('.quantity__input') || this.root.querySelector('input[name="quantity"]');

        this.addEventListener('change', this.handleChange.bind(this));

        if (this.quantityInput) {
          this.quantityInput.addEventListener('change', () => this.updatePrices());
          this.root.querySelectorAll('.quantity__button').forEach((button) => {
            button.addEventListener('click', () => setTimeout(() => this.updatePrices(), 30));
          });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.section) return;
            this.variantId = event.data.variant && event.data.variant.id;
            this.updatePrices();
          });
        }

        this.updatePrices();
      }

      handleChange(event) {
        if (!event.target.matches('[data-selling-plan-radio]')) return;
        this.input.value = event.target.value;
      }

      get quantity() {
        if (!this.quantityInput) return 1;
        return Math.max(1, parseInt(this.quantityInput.value, 10) || 1);
      }

      get currentVariantId() {
        if (this.variantId) return String(this.variantId);
        if (this.variantInput && this.variantInput.value) return String(this.variantInput.value);
        const ids = Object.keys(this.data.variants);
        return ids.length ? ids[0] : null;
      }

      formatMoney(cents) {
        const amount = Math.round(cents) / 100;
        return `${amount.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
      }

      updatePrices(variantId) {
        if (variantId) this.variantId = variantId;

        const variantData = this.data.variants[this.currentVariantId];
        if (!variantData) return;

        const quantity = this.quantity;
        let algunPlanDisponible = false;

        if (this.oneTimePriceEl) this.oneTimePriceEl.textContent = this.formatMoney(variantData.one_time * quantity);

        this.querySelectorAll('[data-plan-price]').forEach((priceEl) => {
          const planId = priceEl.dataset.planPrice;
          const price = variantData.plans[planId];
          const option = priceEl.closest('.selling-plan-selector__option');
          const radio = option ? option.querySelector('[data-selling-plan-radio]') : null;

          if (price != null) {
            algunPlanDisponible = true;
            priceEl.textContent = this.formatMoney(price * quantity);
            if (radio) {
              radio.disabled = false;
              option.classList.remove('selling-plan-selector__option--unavailable');
            }
          } else {
            priceEl.textContent = '';
            if (radio) {
              radio.disabled = true;
              if (radio.checked) {
                radio.checked = false;
                this.input.value = '';
                const oneTimeRadio = this.querySelector('[data-selling-plan-radio][value=""]');
                if (oneTimeRadio) oneTimeRadio.checked = true;
              }
              option.classList.add('selling-plan-selector__option--unavailable');
            }
          }
        });

        // Sin ningún plan para esta variante no hay nada que elegir: fuera la caja entera.
        this.hidden = !algunPlanDisponible;
      }
    }
  );
}
